module.exports = __webpack_public_path__ + "static/JL.190207.COH.WEBW.Gallery5-452ccd7e32968f30543ab3697c03ff85.jpg";